module.exports = __webpack_public_path__ + "img/icon-learning.6bbdff96.png";